export default class DropDownItem {
    constructor(id = null, value = '') {
        this.id = id;
        this.value = value;
    }
}
